import { apiConfig } from "./apiConfig";
const YEARS_TO_FETCH = 18;
const toOtdDate = (year, month, day) => {
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  const yy = String(year % 100).padStart(2, "0");
  return `${mm}.${dd}.1${yy}`;
};

export const getThisDayPosts = (axios) => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const currentYear = now.getFullYear();
  const years = [];

  for (let year = currentYear - 1; year >= currentYear - YEARS_TO_FETCH; year -= 1) {
    years.push(year);
  }

  return Promise.all(
    years.map((year) =>
      axios
        .get(`${apiConfig.oftheday.date}${toOtdDate(year, month, day)}`)
        .then((res) => (res && res.data && res.data.posts) || [])
        .catch(() => [])
    )
  ).then((yearPosts) => ({
    data: {
      posts: yearPosts.flat(),
    },
  }));
};
